import { pathOr, propOr } from 'ramda';
import moment from 'moment-timezone';

import { LOAN_STATUS } from './constants';
import config from '../../config';
import { formatPercentage } from '../common/Percentage';
import { t } from '../../modules/infra/i18n';

export const getAvailableLoanLinkType = pathOr('capital_financing_offer', ['availableLinkTypes', 0]);
export const getAvailableLoanAmount = propOr(0, 'advanceAmount');

export const getLoanTitle = (index) => `${t('loans:offer_title')}${index + 1}`;

export const getLoanStatus = (loan) => {
  if ([LOAN_STATUS.PAID_OUT].includes(loan.status)) {
    return t('loans:status.in_progress');
  }

  if ([LOAN_STATUS.ACCEPTED, LOAN_STATUS.DELIVERED].includes(loan.status)) {
    return t('loans:status.pending');
  }

  return '';
};

export const getTotalLoanAmount = (loan) => {
  if (!loan.summary) {
    return 0;
  }

  return loan.summary.advanceAmount + loan.summary.feeAmount;
};

export const getFormattedRepaidPercent = (loan) => {
  if (!loan.summary) {
    return '';
  }

  return `(${formatPercentage((loan.summary.paidAmount / getTotalLoanAmount(loan)) * 100, 1)})`;
};

export const getFirstPaydownDate = (loan, timezone) => {
  if (!loan.summary) {
    return '';
  }

  return moment.unix(loan.summary.repaymentsBeginAt).tz(timezone).format(config.dateFormat);
};

export const getRepaymentRate = (loan) => {
  if (!loan.summary) {
    return '';
  }

  return `${Math.round(loan.summary.withholdRate * 100)}%`;
};
